import { NotificationConfig, NotificationType } from '@routific/hive';
import i18n from '../../i18n';

export const unpublishRouteFailureNotification = (actionUuid: string): NotificationConfig => ({
  id: `unpublish-route-failed-${actionUuid}`,
  type: NotificationType.ERROR,
  message: i18n.t('notifications:unpublishRoute.failure.message'),
  dataCy: 'unpublish-route-failure-notification',
});

/**
 * The driver was already running the route when it was unpublished and their queued work has now
 * reached us, so the route has gone back to them. A warning rather than a success: the planner
 * believed the route was theirs again, and anything they changed meanwhile is not with the driver.
 */
export const recallRevertedNotification = (routeUuid: string, routeName?: string | null): NotificationConfig => ({
  id: `route-recall-reverted-${routeUuid}`,
  type: NotificationType.WARNING,
  message: routeName
    ? i18n.t('notifications:unpublishRoute.recallReverted.named', { routeName })
    : i18n.t('notifications:unpublishRoute.recallReverted.message'),
  dataCy: 'route-recall-reverted-notification',
});
